// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8YUtt","delete":"styles_delete__ITLQp","update":"styles_update__2mpbg","add":"styles_add__2rD6i"};